<script>
  export let src, alt = '', className = '', aspect = '4x4', pixelated = false, role = '', fadeIn = true, loading = 'lazy'
  import { fade } from 'svelte/transition'

  const [width, height] = aspect.split('x')

  function handleSourceError(e) {
    e.currentTarget.onerror = null;
    e.currentTarget.style.display = 'none';
  }

  function handleImgError(e) {
    const img = e.currentTarget;
    img.onerror = null;
    // Fallback: if both webp and png fail, hide the broken image
    img.style.display = 'none';
  }
</script>

{#if fadeIn}
<picture class={$$restProps.class || ''} in:fade>
  <source onerror={handleSourceError} srcset='{src}.webp' type='image/webp' />
  <img class='{className}' class:pixelated={pixelated} src='{src}.png' {loading} {width} {height} {alt} {role} onerror={handleImgError} />
</picture>
{:else}
<picture class={$$restProps.class || ''}>
  <source onerror={handleSourceError} srcset='{src}.webp' type='image/webp' />
  <img class='{className}' class:pixelated={pixelated} src='{src}.png' {loading} {width} {height} {alt} {role} onerror={handleImgError} />
</picture>
{/if}

<style lang="postcss">
  img.pixelated {
    image-rendering: pixelated;
  }
</style>